import { Button, FormControl, FormHelperText, FormLabel, Input } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useCreateClientMutation } from '@/@generated/codegen/API';
import { captureSentry } from '@/utils/helpers/sentryHelper';

type Props = {
  closeForm: () => void;
};

type FormData = {
  clientName: string;
};

export default function CreateClientForm({ closeForm }: Props) {
  const { t } = useTranslation();
  const [createClientMutation] = useCreateClientMutation();

  const { register, handleSubmit, reset, formState: formState } = useForm<FormData>();

  // --------------------- handlers ------------------------

  const onSubmit = (values: FormData) => {
    void createClientMutation({
      variables: {
        data: {
          name: values.clientName,
        },
      },
    })
      .then(() => {
        closeForm();
      })
      .catch((err) => {
        captureSentry({
          title: 'Error creating client',
          error: err,
        });
      });
  };

  // --------------------- effects ------------------------

  useEffect(() => {
    //reset  fields when component unmounts
    return () => reset();
  }, [closeForm]);

  // --------------------- render ------------------------

  return (
    <form
      onSubmit={(e) => {
        void handleSubmit(onSubmit)(e);
      }}
    >
      {/* CLIENT NAME */}
      <FormControl isRequired isInvalid={Boolean(formState.errors.clientName)}>
        <FormLabel fontSize="sm" fontWeight="normal" mb="1">
          {t('admin.clients.createForm.field.clientname')}:
        </FormLabel>
        <Input type="text" {...register('clientName', { required: true })} placeholder="Name" />
        {formState.errors.clientName && (
          <FormHelperText color="red">
            {t('admin.clients.createForm.field.clientname.error')}
          </FormHelperText>
        )}
      </FormControl>

      {/* SUBMIT */}
      <Button
        onClick={() => {
          void handleSubmit(onSubmit)();
        }}
        marginTop="20px"
        padding="20px"
        background="blue.400"
        color="white"
        variant="solid"
      >
        {t('common.create')}
      </Button>
    </form>
  );
}
